import { gql } from '@apollo/client';

export const ADD_FIND_GROUP_COLLABORATOR_MUTATION = gql`
  mutation AddFindGroupCollaboratorMutation(
    $groupId: String!
    $userId: String!
    $level: Int!
  ) {
    addFindGroupCollaborator(
      groupId: $groupId
      userId: $userId
      level: $level
    ) {
      ... on AddFindGroupCollaboratorSuccess {
        result
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
`;
